const FULL_NAME = 'Morgan Denis';

export default FULL_NAME;
